export default "__VITE_ASSET__B_i1Dcdl__"